import { useMemo } from "react"
import PropTypes from "prop-types"
import { map } from "lodash"
import TableRow from "../table-row"
import NoContributionsRow from "../NoContributionsRow"
import PaginationWrapper from "components/pagination-wrapper"

function TableBody({
  data,
  selected,
  openSecurityProfile,
  openFactorProfile,
  openCompositeSecurity,
  openBasket,
  noPercent,
  hideSelectedField,
  enableBasketDrillDown,
  page,
  setPage,
  formatter,
}) {
  const rows = useMemo(() => map(data, (contributor) =>
    <TableRow
      key={contributor.modelProviderId ? contributor.modelProviderId : contributor.id}
      contributor={contributor}
      selected={selected}
      noPercent={noPercent}
      openSecurityProfile={openSecurityProfile}
      openFactorProfile={openFactorProfile}
      openCompositeSecurity={openCompositeSecurity}
      openBasket={openBasket}
      hideSelectedField={hideSelectedField}
      enableBasketDrillDown={enableBasketDrillDown}
      formatter={formatter}
    />,
  ), [data, enableBasketDrillDown, hideSelectedField, noPercent, openBasket, openFactorProfile, openSecurityProfile, openCompositeSecurity, selected, formatter])

  if (!data.length) {
    const customMessage = selected.id === "tradingPnl" ? "Upload Per Security P&L data to see trading contributions." : ""
    return <NoContributionsRow customMessage={customMessage} />
  }

  return <PaginationWrapper {...{ rows, page, setPage }} />
}

TableBody.propTypes = {
  data: PropTypes.array.isRequired,
  selected: PropTypes.object.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func,
  openBasket: PropTypes.func,
  noPercent: PropTypes.bool,
  hideSelectedField: PropTypes.bool,
  enableBasketDrillDown: PropTypes.bool,
  page: PropTypes.number,
  setPage: PropTypes.func,
  formatter: PropTypes.func,
}

export default TableBody
